export default class extends Controller {
  static targets = ['sortableContainer'];

  connect() {
    this.dragHandler = App.DragHandler.init([...this.sortableContainerTargets], {
      moves: (el, container, handle) => handle.closest('td').classList.contains('drag-handle'),
      dropHandler: this.updateListOrder.bind(this)
    })
  }

  //
  // INTERNAL USE
  //

  updateListOrder(el, target, source, sibling) {
    if (this.orderUpdateURL) {
      App.Helpers.ajaxRequest({
        url: this.orderUpdateURL.replace('ITEM-ID', el.querySelector('[data-target="list-item-id"]').value),
        method: 'post',
        data: { previous_element_id: sibling ? sibling.querySelector('[data-target="list-item-id"]').value : null }
      });
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get orderUpdateURL() {
    return this.data.get('order-update-url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/table-reorder-controller.js